import React, { useEffect, useState } from "react";
import { Cookies } from '../../../../index.js';
import { alert_error, alert_success } from '../../../../AppContext';
import Post_content from '../../../../community/content/Blog_posts.jsx';
import axios from 'axios';
import { Helmet } from "react-helmet";
import AdSense from 'react-adsense';
const AboutUs = ({ base64Image_1, handleImageChange_1,
    base64Image_2, handleImageChange_2
}) => {
    const [show_example, setshow_example] = useState(false);
    return (
        <>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 1: Đọc hướng dẫn và chụp màn hình </h2>
                <div className="text-center">
                    Chụp ảnh màn hình hiện tại
                </div>
            </div>
            <div className="mx-1">
                <div className="mx-1 mx-auto">
                    <div className="cards">
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="3259681051"
                            style={{ display: 'block' }}  // Add pointer-events: none
                            format="auto"
                            responsive="false"
                        />
                    </div>
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 2: Ấn vô quảng cáo và chụp ảnh màn hình</h2>
                <div className="text-center">
                    <li>Ấn vô banner xem đối tác</li>
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 3: Xem hướng dẫn</h2>
                <div className="text-center">
                    <div
                        className="button inline-block px-2 py-1 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition duration-300"
                        onClick={() => setshow_example(!show_example)}
                    >
                        Xem hình ảnh mẫu ở đây
                    </div>
                    {show_example && (
                        <div className="flex text-center">
                            <div className="mx-auto" >
                                <Post_content mode={'telegram'} show_adsense={'NO'} channel={'dangbaiok'} id_post={'19616'} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div>
                <h2 className="text-lg font-bold mb-1">Bước 4: Gửi ảnh</h2>
                <ul className="list-disc pl-6">
                    <li>

                        <div className="text-center">
                            Ảnh màn hình hiện tại:
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange_1}
                                className="rounded"
                            />
                            {base64Image_1 && (
                                <div className="">
                                    <img src={base64Image_1} alt="Selected" className="mx-auto w-44 rounded mr-4" />
                                </div>
                            )}
                        </div>
                        <div>
                            Ảnh quảng cáo của đối tác:
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange_2}
                                className="rounded"
                            />
                            {base64Image_2 && (
                                <div className="">
                                    <img src={base64Image_2} alt="Selected" className="mx-auto w-44 rounded mr-4" />
                                </div>
                            )}
                        </div>
                    </li>

                    <li className="text-sm">Lưu ý: ảnh cần hiển thị rõ quảng cáo và truy cập ở trình duyệt</li>
                </ul>
            </div>
        </>
    );
}

export default AboutUs;
